export default __webpack_public_path__ + "static/media/Remove-Lid.e06d3295.svg";